import { Observable } from 'rxjs';
import { ActionsObservable } from 'redux-observable';
import _ from 'lodash';

import CauseApi from 'entities/cause/api';

import {
  INIT,
  InitActionTemplate,
  initSuccessActionTemplate,
  initFailedActionTemplate,
} from './types';

const loadCauses = (action$: ActionsObservable<InitActionTemplate>) =>
  action$.ofType(INIT).mergeMap(() => {
    const actions = [];

    actions.push(CauseApi.fetchAll());

    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) => [..._.flatten(resultingActions), initSuccessActionTemplate()])
      .catch((e) => Observable.of(initFailedActionTemplate(e)));
  });

export default [loadCauses];
